export const isEmptyString = str => {
  return !str || 0 === str.length
}
